// UrgencyBadge — supply request urgency tier.
// Uppercase, tracked, slightly chunkier than a sentiment pill. Three tiers
// (Emergency/Soon/Planned) with an optional helper line ("Tonight",
// "2–5 days", "1–2 wk") rendered after a middot if `withTimeline` is true.

import { URGENCY_STYLES, type UrgencyTier } from '../design-tokens';

const TIMELINES: Record<UrgencyTier, string> = {
  Emergency: 'Tonight',
  Soon: '2–5 days',
  Planned: '1–2 wk',
};

export interface UrgencyBadgeProps {
  tier: UrgencyTier;
  /** Append the timeline string after the tier name. */
  withTimeline?: boolean;
  className?: string;
}

export function UrgencyBadge({
  tier,
  withTimeline,
  className,
}: UrgencyBadgeProps) {
  const style = URGENCY_STYLES[tier];
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1 rounded-md px-2.5 py-[3px] text-[11px] font-bold uppercase tracking-wider ${className ?? ''}`}
      style={{ backgroundColor: style.fill, color: style.text }}
    >
      <span>{style.label}</span>
      {withTimeline && (
        <>
          <span aria-hidden="true">·</span>
          <span className="font-semibold">{TIMELINES[tier]}</span>
        </>
      )}
    </span>
  );
}
